import PhoneNumber from 'models/PhoneNumberModel';

export const validatePhoneNumbers = (phoneNumbers: PhoneNumber[]) => {
    const validPhoneNumbers = phoneNumbers.filter((number) => number.phoneNumber?.length > 1);
    return validPhoneNumbers;
};
